module.exports = angular.module('date-time-form', [
    require('../../../controllers/triggerPanel/addDateTimeFormCtrl').name
])
    .directive('dateTimeForm', function () {
        return {
            restrict: 'E',
            scope: false,
            templateUrl: 'app/views/triggerPanel/date-time-form.tpl.html',
            controller: 'addDateTimeFormCtrl',
        };
    });



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/triggerPanel/date-time-form.js